import { useTranslation } from 'next-i18next'

import PanelElementContainer from '~/panels/components/PanelElementContainer'
import { parsePhoneNumberWithCallingCode } from '~/utils/helpers'
import SVGIcon from '~/components/Icons/svgs/SVGIcon'
import HomPhoneIcon from '~/components/Icons/svgs/HomPhoneIcon'
import HomEmailIcon from '~/components/Icons/svgs/HomEmailIcon'

export default function PanelContactCard({
  className,
  email,
  header,
  isAlwaysColumn,
  phoneNumber,
}: {
  className?: string
  email: string | null
  header?: string
  isAlwaysColumn?: boolean
  phoneNumber: string | null
}): React.ReactElement {
  const { t } = useTranslation('studentInfo')

  return (
    <PanelElementContainer className={className} header={header}>
      <div className={`space-y-1 flex flex-col ${isAlwaysColumn ? '' : 'lg:space-y-0 lg:space-x-16 lg:flex-row'}`}>
        <div className="space-x-3 flex items-center">
          <div className="shrink-0">
            <SVGIcon icon={HomPhoneIcon} size={20} />
          </div>
          <div>
            <span className="block text-xxs text-gray-light-fade">{t('phoneNumber')}</span>
            <span className="block text-xxs font-medium">{parsePhoneNumberWithCallingCode(phoneNumber)}</span>
          </div>
        </div>
        <div className="space-x-3 flex items-center">
          <div className="shrink-0">
            <SVGIcon icon={HomEmailIcon} size={20} />
          </div>
          <div>
            <span className="block text-xxs text-gray-light-fade">{t('email')}</span>
            <span className="block text-xxs font-medium">{email}</span>
          </div>
        </div>
      </div>
    </PanelElementContainer>
  )
}
